import {
  collection,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import FirebaseFirestore from '../../../services/FirebaseFirestore';

export class McpOAuthRefreshTokenModel {
  constructor({
    id,
    userId,
    clientId,
    scope,
    resource,
    expiresAt,
  }: {
    id: string;
    userId: string;
    clientId: string;
    scope: string;
    resource: string;
    expiresAt: number;
  }) {
    this.id = id;
    this.userId = userId;
    this.clientId = clientId;
    this.scope = scope;
    this.resource = resource;
    this.expiresAt = expiresAt;
  }

  id: string;
  userId: string;
  clientId: string;
  scope: string;
  resource: string;
  expiresAt: number;

  isExpired(): boolean {
    return Date.now() > this.expiresAt;
  }

  /* eslint-disable-next-line */
  static fromJson(id: string, json: { [key: string]: any }): McpOAuthRefreshTokenModel {
    return new McpOAuthRefreshTokenModel({
      id,
      userId: typeof json?.userId === 'string' ? json.userId : '',
      clientId: typeof json?.clientId === 'string' ? json.clientId : '',
      scope: typeof json?.scope === 'string' ? json.scope : 'mcp',
      resource: typeof json?.resource === 'string' ? json.resource : '',
      expiresAt: typeof json?.expiresAt === 'number' ? json.expiresAt : 0,
    });
  }

  /* eslint-disable-next-line */
  toJson(): { [key: string]: any } {
    return {
      userId: this.userId,
      clientId: this.clientId,
      scope: this.scope,
      resource: this.resource,
      expiresAt: this.expiresAt,
    };
  }

  static parent = collection(
    FirebaseFirestore,
    'mcpOAuthRefreshTokens'
  ).withConverter<McpOAuthRefreshTokenModel>({
    toFirestore: (model: McpOAuthRefreshTokenModel) => model.toJson(),
    fromFirestore: (snapshot: QueryDocumentSnapshot) =>
      McpOAuthRefreshTokenModel.fromJson(snapshot.id, snapshot.data()),
  });
}
